import { FC } from 'react';
import { useI18nContext } from '@i18n/i18n-react';
import { ContextMenu } from '@components/context-menu/ContextMenu';
import { FreezeColumns, FreezeGrid, FreezeRows, UnfreezeColumns, UnfreezeRows } from '@components/icons/FarseerIcons';
import { useSheetEditorContext } from '@features/sheet/editor/SheetEditorProvider';

export type SheetFreezeMenuProps = {
    rowIndex?: number;
    columnIndex?: number;
};

export const SheetFreezeMenu: FC<SheetFreezeMenuProps> = (props: SheetFreezeMenuProps) => {
    const { LL } = useI18nContext();

    const { rowIndex, columnIndex } = props;
    const {
        state: {
            sheetConfig: { display },
        },
        api: { updateConfig },
    } = useSheetEditorContext();

    const { freezeRows, freezeColumns } = display;

    const hasColumn = columnIndex != null && columnIndex >= 0;
    const hasRow = rowIndex != null;

    return (
        <ContextMenu.Item
            item={{
                icon: FreezeGrid,
                label: LL.FREEZE_PANES(),
            }}
        >
            {hasColumn ? (
                <>
                    <ContextMenu.Item
                        item={{
                            icon: FreezeColumns,
                            label: LL.FREEZE_UP_TO_THIS_COLUMN(),
                            action: () => {
                                updateConfig({ display: { freezeColumns: columnIndex + 1 } });
                            },
                        }}
                    />
                    <ContextMenu.Item
                        item={{
                            icon: UnfreezeColumns,
                            label: LL.UNFREEZE_COLUMNS(),
                            disabled: freezeColumns === 0,
                            action: () => {
                                updateConfig({ display: { freezeColumns: 0 } });
                            },
                        }}
                    />
                </>
            ) : null}
            {hasColumn && hasRow ? <ContextMenu.Divider /> : null}
            {hasRow ? (
                <>
                    <ContextMenu.Item
                        item={{
                            icon: FreezeRows,
                            label: LL.FREEZE_UP_TO_THIS_ROW(),
                            action: () => {
                                updateConfig({ display: { freezeRows: rowIndex + 1 } });
                            },
                        }}
                    />
                    <ContextMenu.Item
                        item={{
                            icon: UnfreezeRows,
                            label: LL.UNFREEZE_ROWS(),
                            disabled: !freezeRows,
                            action: () => {
                                updateConfig({ display: { freezeRows: 0 } });
                            },
                        }}
                    />
                </>
            ) : null}
        </ContextMenu.Item>
    );
};
